import { render } from "./coverImgTemplate.vue?vue&type=template&id=be09cee4&scoped=true"
import script from "./coverImgTemplate.vue?vue&type=script&lang=js"
export * from "./coverImgTemplate.vue?vue&type=script&lang=js"

import "./coverImgTemplate.vue?vue&type=style&index=0&id=be09cee4&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be09cee4"]])

export default __exports__